export default __webpack_public_path__ + "static/Peerpower_logo-ac093ee49dc5e9185af72bd5fb7e5d7a.png";